import { Outlet, Link } from "react-router-dom";
import Navbar from "../sections/web_core/Navbar";
import HeroSection from "../sections/web_core/Herosection";
import CoursesCarousel from "../sections/web_core/CourseCaraousal";
import Footer from "../sections/web_core/Footer";
import BlogCarousel from "../sections/content_component/BlogCaraousal";
import FeaturesSection from "../sections/web_core/FeatureSection";
import ReviewsSection from "../sections/web_core/ReviewSection";
import InstructorsSection from "../sections/scholar_comp/InstructorSection";
import Aboutmain from "../sections/web_core/aboutmain";
import IMAGE_3 from "../Assets/Home/imgi_26_6.jpg";
import IMAGE_4 from "../Assets/Home/imgi_27_7.jpg";
import IMAGE_5 from "../Assets/Home/imgi_28_8.jpg";
import IMAGE_6 from "../Assets/Home/imgi_25_5.jpg";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import GroupsIcon from "@mui/icons-material/Groups";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import ChatbotButton from "../sections/chatbot/chatbot";
/* =========================
   Section Wrapper
   ========================= */
const SectionWrapper = ({ children, className = "" }) => {
  return (
    <section
      className={`w-full ${className}`}
      style={{ marginBottom: "5px" }}
    >
      {children}
    </section>
  );
};

const CrownSection = () => {
  const services = [
    {
      id: "01",
      title: "Online Classes",
      desc: "Learn Quran online with qualified teachers through interactive sessions tailored to your level.",
      icon: <MenuBookIcon sx={{ fontSize: 26 }} />,
    },
    {
      id: "02",
      title: "One-to-One Sessions",
      desc: "Deep dive into the meanings of the Quran with comprehensive courses from scholars.",
      icon: <AutoStoriesIcon sx={{ fontSize: 26 }} />,
    },
    {
      id: "03",
      title: "Student Centric",
      desc: "Personalized attention and flexible scheduling to ensure the best experience.",
      icon: <GroupsIcon sx={{ fontSize: 26 }} />,
    },
  ];

  return (
    <div className="relative flex flex-col items-center">

      
      <div className="w-full flex justify-center">
        <div
          className="relative  z-20 w-[82%] flex flex-col md:flex-row items-center justify-between px-8 py-6 rounded-3xl gap-4 md:gap-6"
          style={{ background: "linear-gradient(to right, #16a34a, #fbbf24)" }}
        >
          <p className="text-white  text-base pt-9 py-9 md:text-lg font-semibold text-center md:text-left leading-relaxed">
            Do Not Let Shaitan Delay You From
            <br className="hidden md:block" />
            Starting To Learn Your Deen.
          </p>

          <Link
            to="/lead-form"
            className="bg-white text-green-900 rounded-lg px-8 py-3.5 font-bold hover:scale-105 transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            Quick Start Now
          </Link>
        </div>
      </div>
      <div className=" p-1">

      </div>
      {/* WHAT WE OFFER */}
      <div className="w-[80%] bg-green-800 rounded-b-3xl p-6 md:p-10 relative">

        <div className="text-center mb-10">
          <h5 className="text-green-300 text-sm font-bold tracking-widest uppercase mb-2">
            What We Offer
          </h5>
          <h2 className="text-white text-3xl md:text-4xl font-extrabold">
            Effective Arabic & Quran Services
          </h2>
          <div className="w-12 h-1 bg-yellow-400 mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex justify-between items-start mb-4">
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center text-white"
                  style={{
                    background:
                      "linear-gradient(135deg, #16a34a 0%, #fbbf24 100%)",
                  }}
                >
                  {item.icon}
                </div>
                <div className="text-gray-400 text-xl font-black">
                  {item.id}
                </div>
              </div>

              <h3 className="text-green-900 text-base font-bold mb-2">
                {item.title}
              </h3>

              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                {item.desc}
              </p>

              <Link
                to="/lead-form"
                className="flex items-center text-green-700 font-semibold text-xs uppercase tracking-wider group-hover:text-green-500"
              >
                Read More
                <ArrowForwardIcon
                  sx={{ fontSize: 15, ml: 1 }}
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

/* =========================
   Gallery Section
========================= */
const GallerySection = () => {
  const images = [IMAGE_3, IMAGE_4, IMAGE_5, IMAGE_6];

  return (
    <div className="w-full px-6 md:px-10">

      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-8">
        <div>
          <h5 className="text-green-400 text-sm uppercase tracking-widest mb-1">
            Student Gallery
          </h5>
          <h2 className="text-green-900 text-3xl md:text-4xl font-extrabold">
            Our Islamic Institute Academic Gallery
          </h2>
        </div>

        <Link
          to="/lead-form"
          className="bg-green-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-800 transition-all duration-300 mt-4 lg:mt-0"
        >
          Quick Join Now
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="aspect-square overflow-hidden rounded-2xl shadow-md hover:shadow-lg transition-all duration-300"
          >
            <img
              src={img}
              alt={`Gallery ${idx + 1}`}
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

/* =========================
   Home Page
========================= */
const HomePage = () => {
  return (
    <div className="bg-white min-h-screen flex flex-col">

      <Navbar />
      <Outlet />

      <HeroSection />

      <SectionWrapper>
        <Aboutmain />
      </SectionWrapper>

      <SectionWrapper>
        <CoursesCarousel />
      </SectionWrapper>

      <SectionWrapper>
        <CrownSection />
      </SectionWrapper>

      <SectionWrapper>
        <FeaturesSection />
      </SectionWrapper>

      <SectionWrapper>
        <GallerySection />
      </SectionWrapper>

      <SectionWrapper>
        <ReviewsSection />
      </SectionWrapper>

      <SectionWrapper>
        <InstructorsSection />
      </SectionWrapper>

      <SectionWrapper>
        <BlogCarousel />
      </SectionWrapper>
      <ChatbotButton />
      <Footer />

    </div>
  );
};

export default HomePage;